import { del, get, post, put } from "../api"
import * as url from "./urls"

const getAllShippingCompanies = () => {
  return get(url.GET_ALL_SHIPPING_COMPANIES)
}

const getAllShippingCompaniesParanoid = () => {
  return get(url.GET_ALL_SHIPPING_COMPANIES_PARANOID)
}

const getShippingCompanyById = id => {
  return get(url.GET_SHIPPING_COMPANY_BY_ID.replace(":id", id))
}

const getAllShippingCompaniesParanoidWithProducts = () => {
  return get(url.GET_ALL_SHIPPING_COMPANIES_PARANOID_WITH_PRODUCTS)
}

const postNovaTransporadora = data => {
  return post(url.POST_SHIPPING_COMPANY, data)
}

const updateTransportadora = data => {
  const endpoint = url.UPDATE_COMPANY_BY_ID.replace(":id", data?.id)
  return post(endpoint, data)
}

const deleteTransportadora = id => {
  const endpoint = url.DELETE_COMPANY_BY_ID.replace(":id", id)
  return del(endpoint)
}

const restoreTransportadora = id => {
  const endpoint = url.RESTORE_COMPANY_BY_ID.replace(":id", id)
  return post(endpoint)
}

const updateSLA = data => {
  return put(url.UPDATE_SHIPPING_COMPANIES, data)
}

const getAllWithStatusMapping = id => {
  const endpoint = url.GET_SHIPPING_EVENTS_WITH_MAPPING.replace(":id", id)
  return get(endpoint)
}

const getStatus = () => {
  return get(url.GET_STATUS)
}

const getOne = id => {
  const endpoint = url.GET_SHIPPING_EVENT.replace(":id", id)
  return get(endpoint)
}

const updateOne = (id, data) => {
  const endpoint = url.UPDATE_SHIPPING_EVENT.replace(":id", id)
  return put(endpoint, data, {
    method: "PUT",
  })
}

export {
  getAllShippingCompanies,
  getAllShippingCompaniesParanoid,
  getAllShippingCompaniesParanoidWithProducts,
  getShippingCompanyById,
  postNovaTransporadora,
  updateTransportadora,
  restoreTransportadora,
  deleteTransportadora,
  updateSLA,
  getAllWithStatusMapping,
  getStatus,
  getOne,
  updateOne,
}
